<script setup lang="ts">
import './media-preview.scss';

const props = defineProps({
    item: {
        type: Object as PropType<any>
    },
    type: {
        type: String,
        default: ''
    },
    url: {
        type: [String, null] as PropType<string | null>,
        default: ''
    }
});
const itemData = ref<any>({});
if (props.item?.id) {
    itemData.value = props.item;
}

// item data
const name = itemData.value?.name;
const poster = itemData.value?.poster?.sizes?.[280];
const productionYear = itemData.value?.productionYear;
const countries = itemData.value?.countries?.map((item: any) => item?.name);
const categories = itemData.value?.categories?.map((item: any) => item?.name);

const url = computed(() => {
    if (props.url) {
        return props.url;
    } else if (itemData.value?.container?.id) {
        const rootContainerId = itemData.value.container?.parentId || itemData.value.container.id;
        return useUrl(
            {
                id: rootContainerId
            },
            'container'
        );
    } else {
        return useUrl(itemData.value, props.type);
    }
});

// duration
const duration = ref<number | undefined>();
const time = ref<number | undefined>();
if (itemData.value?.lastViewedItem) {
    duration.value = itemData.value?.lastViewedItem?.item?.duration
        ? Math.floor(Number(itemData.value?.lastViewedItem?.item?.duration) * 60)
        : undefined;
    time.value = itemData.value?.lastViewedItem?.item?.time
        ? Number(itemData.value?.lastViewedItem?.item?.time)
        : undefined;
} else {
    duration.value = itemData.value?.duration ? Math.floor(Number(itemData.value?.duration) * 60) : undefined;
    time.value = itemData.value?.time ? Number(itemData.value?.time) : undefined;
}

if (!time.value && duration.value) {
    time.value = duration.value * 0.01;
}

const emit = defineEmits(['focused']);
const onFocused = (event: any) => emit('focused', event);
</script>

<template>
    <LrudNode isFocusable class="media-preview media-preview_big" @selected="navigateTo(url)" @focused="onFocused">
        <div class="media-preview__header">
            <span class="media-preview__image">
                <img v-if="poster" :src="poster" :alt="name" />
            </span>
            <MediaPreviewStatus v-if="duration && time" :duration="duration" :time="time" />
        </div>
        <span class="media-preview__content">
            <span class="media-preview__name title fs-22">
                {{ name }}
            </span>

            <span class="media-preview__text d-block pt-8 fs-20">
                <span v-if="!isEmpty(categories)" class="d-block mt-4">
                    жанр:
                    <span v-html="categories.join(', ')"></span>
                </span>

                <span v-if="!isEmpty(countries)" class="d-block mt-4">
                    страна:
                    <span v-html="countries.join(', ')"></span>
                </span>

                <span v-if="!isNil(productionYear)" class="d-block mt-4">
                    год: <span>{{ productionYear }}</span>
                </span>
            </span>
        </span>
    </LrudNode>
</template>
